/* eslint-disable */
// @ts-nocheck
// biome-ignore lint: generated file

// This file is normally regenerated by @tanstack/router-plugin during
// `vite dev` / `vite build`. We commit a minimal hand-written version so
// `pnpm typecheck` works in CI without first running a Vite build.
// Once @tanstack/router-cli ships a fix for the 1.95 generator regression,
// remove this file from git and rely on the plugin only.

import { Route as rootRoute } from './routes/__root';
import { Route as HomeImport } from './routes/home';
import { Route as NotificationsImport } from './routes/notifications';
import { Route as WorkspaceSlugHomeImport } from './routes/$workspaceSlug.home';
import { Route as WorkspaceSlugNotificationsImport } from './routes/$workspaceSlug.notifications';
import { Route as SpecImport } from './routes/spec';
import { Route as WorkspaceSlugSpecImport } from './routes/$workspaceSlug.spec';
import { Route as SettingsSignalsImport } from './routes/settings/signals';
import { Route as WorkspaceSlugSettingsSignalsImport } from './routes/$workspaceSlug.settings.signals';
import { Route as SettingsNotificationsImport } from './routes/settings/notifications';
import { Route as WorkspaceSlugSettingsNotificationsImport } from './routes/$workspaceSlug.settings.notifications';
import { Route as SettingsApiKeysImport } from './routes/settings/api-keys';
import { Route as WorkspaceSlugSettingsApiKeysImport } from './routes/$workspaceSlug.settings.api-keys';
import { Route as SettingsDeveloperMcpImport } from './routes/settings.developer.mcp';
import { Route as WorkspaceSlugSettingsDeveloperMcpImport } from './routes/$workspaceSlug.settings.developer.mcp';
import { Route as ConnectorsImport } from './routes/connectors';
import { Route as WorkspaceSlugConnectorsImport } from './routes/$workspaceSlug.connectors';
import { Route as SkillsImport } from './routes/skills';
import { Route as WorkspaceSlugSkillsImport } from './routes/$workspaceSlug.skills';
import { Route as KnowledgeImport } from './routes/knowledge';
import { Route as WorkspaceSlugKnowledgeImport } from './routes/$workspaceSlug.knowledge';
import { Route as FeedImport } from './routes/feed';
import { Route as WorkspaceSlugFeedImport } from './routes/$workspaceSlug.feed';
import { Route as SettingsSpecAiToolsImport } from './routes/settings.spec-ai.tools';
import { Route as WorkspaceSlugSettingsSpecAiToolsImport } from './routes/$workspaceSlug.settings.spec-ai.tools';
import { Route as SettingsScoringEntityImport } from './routes/settings.scoring.$entity';
import { Route as WorkspaceSlugSettingsScoringEntityImport } from './routes/$workspaceSlug.settings.scoring.$entity';
import { Route as WorkspaceSlugAccountsImport } from './routes/$workspaceSlug.accounts';
import { Route as WorkspaceSlugContactsImport } from './routes/$workspaceSlug.contacts';
import { Route as WorkspaceSlugProjectsImport } from './routes/$workspaceSlug.projects';
import { Route as WorkspaceSlugSettingsAppearanceImport } from './routes/$workspaceSlug.settings.appearance';
import { Route as WorkspaceSlugSettingsBillingImport } from './routes/$workspaceSlug.settings.billing';
import { Route as WorkspaceSlugSettingsUsageImport } from './routes/$workspaceSlug.settings.usage';
import { Route as WorkspaceSlugSettingsGeneralImport } from './routes/$workspaceSlug.settings.general';
import { Route as WorkspaceSlugSettingsMembersImport } from './routes/$workspaceSlug.settings.members';
import { Route as WorkspaceSlugSettingsProfileImport } from './routes/$workspaceSlug.settings.profile';
import { Route as WorkspaceSlugSettingsSecurityImport } from './routes/$workspaceSlug.settings.security';
import { Route as WorkspaceSlugSettingsImport } from './routes/$workspaceSlug.settings';
import { Route as WorkspaceSlugWelcomeImport } from './routes/$workspaceSlug.welcome';
import { Route as AccountsImport } from './routes/accounts';
import { Route as ContactsImport } from './routes/contacts';
import { Route as IndexImport } from './routes/index';
import { Route as InvitesTokenImport } from './routes/invites.$token';
import { Route as ProjectsImport } from './routes/projects';
import { Route as SettingsImport } from './routes/settings';
import { Route as SettingsAppearanceImport } from './routes/settings/appearance';
import { Route as SettingsBillingImport } from './routes/settings/billing';
import { Route as SettingsUsageImport } from './routes/settings/usage';
import { Route as SettingsGeneralImport } from './routes/settings/general';
import { Route as SettingsMembersImport } from './routes/settings/members';
import { Route as SettingsProfileImport } from './routes/settings/profile';
import { Route as SettingsSecurityImport } from './routes/settings/security';
import { Route as SigninImport } from './routes/signin';
import { Route as SignupWorkspaceImport } from './routes/signup.workspace';
import { Route as SignupImport } from './routes/signup';
import { Route as WorkspacesSelectImport } from './routes/workspaces.select';

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const HomeRoute = HomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRoute,
} as any);

const NotificationsRoute = NotificationsImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugHomeRoute = WorkspaceSlugHomeImport.update({
  id: '/$workspaceSlug/home',
  path: '/$workspaceSlug/home',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugNotificationsRoute = WorkspaceSlugNotificationsImport.update({
  id: '/$workspaceSlug/notifications',
  path: '/$workspaceSlug/notifications',
  getParentRoute: () => rootRoute,
} as any);

const SpecRoute = SpecImport.update({
  id: '/spec',
  path: '/spec',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSpecRoute = WorkspaceSlugSpecImport.update({
  id: '/$workspaceSlug/spec',
  path: '/$workspaceSlug/spec',
  getParentRoute: () => rootRoute,
} as any);

const ProjectsRoute = ProjectsImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRoute,
} as any);

const AccountsRoute = AccountsImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRoute,
} as any);

const ContactsRoute = ContactsImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => rootRoute,
} as any);

const InvitesTokenRoute = InvitesTokenImport.update({
  id: '/invites/$token',
  path: '/invites/$token',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugProjectsRoute = WorkspaceSlugProjectsImport.update({
  id: '/$workspaceSlug/projects',
  path: '/$workspaceSlug/projects',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugAccountsRoute = WorkspaceSlugAccountsImport.update({
  id: '/$workspaceSlug/accounts',
  path: '/$workspaceSlug/accounts',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugContactsRoute = WorkspaceSlugContactsImport.update({
  id: '/$workspaceSlug/contacts',
  path: '/$workspaceSlug/contacts',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugWelcomeRoute = WorkspaceSlugWelcomeImport.update({
  id: '/$workspaceSlug/welcome',
  path: '/$workspaceSlug/welcome',
  getParentRoute: () => rootRoute,
} as any);

const SigninRoute = SigninImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRoute,
} as any);

const SignupRoute = SignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any);

const SignupWorkspaceRoute = SignupWorkspaceImport.update({
  id: '/signup/workspace',
  path: '/signup/workspace',
  getParentRoute: () => rootRoute,
} as any);

const WorkspacesSelectRoute = WorkspacesSelectImport.update({
  id: '/workspaces/select',
  path: '/workspaces/select',
  getParentRoute: () => rootRoute,
} as any);

const SettingsRoute = SettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any);

const SettingsProfileRoute = SettingsProfileImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => rootRoute,
} as any);

const SettingsGeneralRoute = SettingsGeneralImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => rootRoute,
} as any);

const SettingsMembersRoute = SettingsMembersImport.update({
  id: '/settings/members',
  path: '/settings/members',
  getParentRoute: () => rootRoute,
} as any);

const SettingsSecurityRoute = SettingsSecurityImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => rootRoute,
} as any);

const SettingsBillingRoute = SettingsBillingImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => rootRoute,
} as any);

const SettingsUsageRoute = SettingsUsageImport.update({
  id: '/settings/usage',
  path: '/settings/usage',
  getParentRoute: () => rootRoute,
} as any);

const SettingsAppearanceRoute = SettingsAppearanceImport.update({
  id: '/settings/appearance',
  path: '/settings/appearance',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsRoute = WorkspaceSlugSettingsImport.update({
  id: '/$workspaceSlug/settings',
  path: '/$workspaceSlug/settings',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsProfileRoute = WorkspaceSlugSettingsProfileImport.update({
  id: '/$workspaceSlug/settings/profile',
  path: '/$workspaceSlug/settings/profile',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsGeneralRoute = WorkspaceSlugSettingsGeneralImport.update({
  id: '/$workspaceSlug/settings/general',
  path: '/$workspaceSlug/settings/general',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsMembersRoute = WorkspaceSlugSettingsMembersImport.update({
  id: '/$workspaceSlug/settings/members',
  path: '/$workspaceSlug/settings/members',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsSecurityRoute = WorkspaceSlugSettingsSecurityImport.update({
  id: '/$workspaceSlug/settings/security',
  path: '/$workspaceSlug/settings/security',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsBillingRoute = WorkspaceSlugSettingsBillingImport.update({
  id: '/$workspaceSlug/settings/billing',
  path: '/$workspaceSlug/settings/billing',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsUsageRoute = WorkspaceSlugSettingsUsageImport.update({
  id: '/$workspaceSlug/settings/usage',
  path: '/$workspaceSlug/settings/usage',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsAppearanceRoute = WorkspaceSlugSettingsAppearanceImport.update({
  id: '/$workspaceSlug/settings/appearance',
  path: '/$workspaceSlug/settings/appearance',
  getParentRoute: () => rootRoute,
} as any);

const SettingsSignalsRoute = SettingsSignalsImport.update({
  id: '/settings/signals',
  path: '/settings/signals',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsSignalsRoute = WorkspaceSlugSettingsSignalsImport.update({
  id: '/$workspaceSlug/settings/signals',
  path: '/$workspaceSlug/settings/signals',
  getParentRoute: () => rootRoute,
} as any);

const SettingsNotificationsRoute = SettingsNotificationsImport.update({
  id: '/settings/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsNotificationsRoute = WorkspaceSlugSettingsNotificationsImport.update({
  id: '/$workspaceSlug/settings/notifications',
  path: '/$workspaceSlug/settings/notifications',
  getParentRoute: () => rootRoute,
} as any);

const SettingsApiKeysRoute = SettingsApiKeysImport.update({
  id: '/settings/api-keys',
  path: '/settings/api-keys',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsApiKeysRoute = WorkspaceSlugSettingsApiKeysImport.update({
  id: '/$workspaceSlug/settings/api-keys',
  path: '/$workspaceSlug/settings/api-keys',
  getParentRoute: () => rootRoute,
} as any);

const SettingsDeveloperMcpRoute = SettingsDeveloperMcpImport.update({
  id: '/settings/developer/mcp',
  path: '/settings/developer/mcp',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsDeveloperMcpRoute = WorkspaceSlugSettingsDeveloperMcpImport.update({
  id: '/$workspaceSlug/settings/developer/mcp',
  path: '/$workspaceSlug/settings/developer/mcp',
  getParentRoute: () => rootRoute,
} as any);

const ConnectorsRoute = ConnectorsImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugConnectorsRoute = WorkspaceSlugConnectorsImport.update({
  id: '/$workspaceSlug/connectors',
  path: '/$workspaceSlug/connectors',
  getParentRoute: () => rootRoute,
} as any);

const SkillsRoute = SkillsImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSkillsRoute = WorkspaceSlugSkillsImport.update({
  id: '/$workspaceSlug/skills',
  path: '/$workspaceSlug/skills',
  getParentRoute: () => rootRoute,
} as any);

const KnowledgeRoute = KnowledgeImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugKnowledgeRoute = WorkspaceSlugKnowledgeImport.update({
  id: '/$workspaceSlug/knowledge',
  path: '/$workspaceSlug/knowledge',
  getParentRoute: () => rootRoute,
} as any);

const FeedRoute = FeedImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugFeedRoute = WorkspaceSlugFeedImport.update({
  id: '/$workspaceSlug/feed',
  path: '/$workspaceSlug/feed',
  getParentRoute: () => rootRoute,
} as any);

const SettingsSpecAiToolsRoute = SettingsSpecAiToolsImport.update({
  id: '/settings/spec-ai/tools',
  path: '/settings/spec-ai/tools',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsSpecAiToolsRoute = WorkspaceSlugSettingsSpecAiToolsImport.update({
  id: '/$workspaceSlug/settings/spec-ai/tools',
  path: '/$workspaceSlug/settings/spec-ai/tools',
  getParentRoute: () => rootRoute,
} as any);

const SettingsScoringEntityRoute = SettingsScoringEntityImport.update({
  id: '/settings/scoring/$entity',
  path: '/settings/scoring/$entity',
  getParentRoute: () => rootRoute,
} as any);

const WorkspaceSlugSettingsScoringEntityRoute = WorkspaceSlugSettingsScoringEntityImport.update({
  id: '/$workspaceSlug/settings/scoring/$entity',
  path: '/$workspaceSlug/settings/scoring/$entity',
  getParentRoute: () => rootRoute,
} as any);

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/home': {
      id: '/home';
      path: '/home';
      fullPath: '/home';
      preLoaderRoute: typeof HomeImport;
      parentRoute: typeof rootRoute;
    };
    '/notifications': {
      id: '/notifications';
      path: '/notifications';
      fullPath: '/notifications';
      preLoaderRoute: typeof NotificationsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/home': {
      id: '/$workspaceSlug/home';
      path: '/$workspaceSlug/home';
      fullPath: '/$workspaceSlug/home';
      preLoaderRoute: typeof WorkspaceSlugHomeImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/notifications': {
      id: '/$workspaceSlug/notifications';
      path: '/$workspaceSlug/notifications';
      fullPath: '/$workspaceSlug/notifications';
      preLoaderRoute: typeof WorkspaceSlugNotificationsImport;
      parentRoute: typeof rootRoute;
    };
    '/spec': {
      id: '/spec';
      path: '/spec';
      fullPath: '/spec';
      preLoaderRoute: typeof SpecImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/spec': {
      id: '/$workspaceSlug/spec';
      path: '/$workspaceSlug/spec';
      fullPath: '/$workspaceSlug/spec';
      preLoaderRoute: typeof WorkspaceSlugSpecImport;
      parentRoute: typeof rootRoute;
    };
    '/projects': {
      id: '/projects';
      path: '/projects';
      fullPath: '/projects';
      preLoaderRoute: typeof ProjectsImport;
      parentRoute: typeof rootRoute;
    };
    '/accounts': {
      id: '/accounts';
      path: '/accounts';
      fullPath: '/accounts';
      preLoaderRoute: typeof AccountsImport;
      parentRoute: typeof rootRoute;
    };
    '/contacts': {
      id: '/contacts';
      path: '/contacts';
      fullPath: '/contacts';
      preLoaderRoute: typeof ContactsImport;
      parentRoute: typeof rootRoute;
    };
    '/invites/$token': {
      id: '/invites/$token';
      path: '/invites/$token';
      fullPath: '/invites/$token';
      preLoaderRoute: typeof InvitesTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/projects': {
      id: '/$workspaceSlug/projects';
      path: '/$workspaceSlug/projects';
      fullPath: '/$workspaceSlug/projects';
      preLoaderRoute: typeof WorkspaceSlugProjectsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/accounts': {
      id: '/$workspaceSlug/accounts';
      path: '/$workspaceSlug/accounts';
      fullPath: '/$workspaceSlug/accounts';
      preLoaderRoute: typeof WorkspaceSlugAccountsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/contacts': {
      id: '/$workspaceSlug/contacts';
      path: '/$workspaceSlug/contacts';
      fullPath: '/$workspaceSlug/contacts';
      preLoaderRoute: typeof WorkspaceSlugContactsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/welcome': {
      id: '/$workspaceSlug/welcome';
      path: '/$workspaceSlug/welcome';
      fullPath: '/$workspaceSlug/welcome';
      preLoaderRoute: typeof WorkspaceSlugWelcomeImport;
      parentRoute: typeof rootRoute;
    };
    '/signin': {
      id: '/signin';
      path: '/signin';
      fullPath: '/signin';
      preLoaderRoute: typeof SigninImport;
      parentRoute: typeof rootRoute;
    };
    '/signup': {
      id: '/signup';
      path: '/signup';
      fullPath: '/signup';
      preLoaderRoute: typeof SignupImport;
      parentRoute: typeof rootRoute;
    };
    '/signup/workspace': {
      id: '/signup/workspace';
      path: '/signup/workspace';
      fullPath: '/signup/workspace';
      preLoaderRoute: typeof SignupWorkspaceImport;
      parentRoute: typeof rootRoute;
    };
    '/workspaces/select': {
      id: '/workspaces/select';
      path: '/workspaces/select';
      fullPath: '/workspaces/select';
      preLoaderRoute: typeof WorkspacesSelectImport;
      parentRoute: typeof rootRoute;
    };
    '/settings': {
      id: '/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof SettingsImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/profile': {
      id: '/settings/profile';
      path: '/settings/profile';
      fullPath: '/settings/profile';
      preLoaderRoute: typeof SettingsProfileImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/general': {
      id: '/settings/general';
      path: '/settings/general';
      fullPath: '/settings/general';
      preLoaderRoute: typeof SettingsGeneralImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/members': {
      id: '/settings/members';
      path: '/settings/members';
      fullPath: '/settings/members';
      preLoaderRoute: typeof SettingsMembersImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/security': {
      id: '/settings/security';
      path: '/settings/security';
      fullPath: '/settings/security';
      preLoaderRoute: typeof SettingsSecurityImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/billing': {
      id: '/settings/billing';
      path: '/settings/billing';
      fullPath: '/settings/billing';
      preLoaderRoute: typeof SettingsBillingImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/usage': {
      id: '/settings/usage';
      path: '/settings/usage';
      fullPath: '/settings/usage';
      preLoaderRoute: typeof SettingsUsageImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/appearance': {
      id: '/settings/appearance';
      path: '/settings/appearance';
      fullPath: '/settings/appearance';
      preLoaderRoute: typeof SettingsAppearanceImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings': {
      id: '/$workspaceSlug/settings';
      path: '/$workspaceSlug/settings';
      fullPath: '/$workspaceSlug/settings';
      preLoaderRoute: typeof WorkspaceSlugSettingsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/profile': {
      id: '/$workspaceSlug/settings/profile';
      path: '/$workspaceSlug/settings/profile';
      fullPath: '/$workspaceSlug/settings/profile';
      preLoaderRoute: typeof WorkspaceSlugSettingsProfileImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/general': {
      id: '/$workspaceSlug/settings/general';
      path: '/$workspaceSlug/settings/general';
      fullPath: '/$workspaceSlug/settings/general';
      preLoaderRoute: typeof WorkspaceSlugSettingsGeneralImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/members': {
      id: '/$workspaceSlug/settings/members';
      path: '/$workspaceSlug/settings/members';
      fullPath: '/$workspaceSlug/settings/members';
      preLoaderRoute: typeof WorkspaceSlugSettingsMembersImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/security': {
      id: '/$workspaceSlug/settings/security';
      path: '/$workspaceSlug/settings/security';
      fullPath: '/$workspaceSlug/settings/security';
      preLoaderRoute: typeof WorkspaceSlugSettingsSecurityImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/billing': {
      id: '/$workspaceSlug/settings/billing';
      path: '/$workspaceSlug/settings/billing';
      fullPath: '/$workspaceSlug/settings/billing';
      preLoaderRoute: typeof WorkspaceSlugSettingsBillingImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/usage': {
      id: '/$workspaceSlug/settings/usage';
      path: '/$workspaceSlug/settings/usage';
      fullPath: '/$workspaceSlug/settings/usage';
      preLoaderRoute: typeof WorkspaceSlugSettingsUsageImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/appearance': {
      id: '/$workspaceSlug/settings/appearance';
      path: '/$workspaceSlug/settings/appearance';
      fullPath: '/$workspaceSlug/settings/appearance';
      preLoaderRoute: typeof WorkspaceSlugSettingsAppearanceImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/signals': {
      id: '/settings/signals';
      path: '/settings/signals';
      fullPath: '/settings/signals';
      preLoaderRoute: typeof SettingsSignalsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/signals': {
      id: '/$workspaceSlug/settings/signals';
      path: '/$workspaceSlug/settings/signals';
      fullPath: '/$workspaceSlug/settings/signals';
      preLoaderRoute: typeof WorkspaceSlugSettingsSignalsImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/notifications': {
      id: '/settings/notifications';
      path: '/settings/notifications';
      fullPath: '/settings/notifications';
      preLoaderRoute: typeof SettingsNotificationsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/notifications': {
      id: '/$workspaceSlug/settings/notifications';
      path: '/$workspaceSlug/settings/notifications';
      fullPath: '/$workspaceSlug/settings/notifications';
      preLoaderRoute: typeof WorkspaceSlugSettingsNotificationsImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/api-keys': {
      id: '/settings/api-keys';
      path: '/settings/api-keys';
      fullPath: '/settings/api-keys';
      preLoaderRoute: typeof SettingsApiKeysImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/api-keys': {
      id: '/$workspaceSlug/settings/api-keys';
      path: '/$workspaceSlug/settings/api-keys';
      fullPath: '/$workspaceSlug/settings/api-keys';
      preLoaderRoute: typeof WorkspaceSlugSettingsApiKeysImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/developer/mcp': {
      id: '/settings/developer/mcp';
      path: '/settings/developer/mcp';
      fullPath: '/settings/developer/mcp';
      preLoaderRoute: typeof SettingsDeveloperMcpImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/developer/mcp': {
      id: '/$workspaceSlug/settings/developer/mcp';
      path: '/$workspaceSlug/settings/developer/mcp';
      fullPath: '/$workspaceSlug/settings/developer/mcp';
      preLoaderRoute: typeof WorkspaceSlugSettingsDeveloperMcpImport;
      parentRoute: typeof rootRoute;
    };
    '/connectors': {
      id: '/connectors';
      path: '/connectors';
      fullPath: '/connectors';
      preLoaderRoute: typeof ConnectorsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/connectors': {
      id: '/$workspaceSlug/connectors';
      path: '/$workspaceSlug/connectors';
      fullPath: '/$workspaceSlug/connectors';
      preLoaderRoute: typeof WorkspaceSlugConnectorsImport;
      parentRoute: typeof rootRoute;
    };
    '/skills': {
      id: '/skills';
      path: '/skills';
      fullPath: '/skills';
      preLoaderRoute: typeof SkillsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/skills': {
      id: '/$workspaceSlug/skills';
      path: '/$workspaceSlug/skills';
      fullPath: '/$workspaceSlug/skills';
      preLoaderRoute: typeof WorkspaceSlugSkillsImport;
      parentRoute: typeof rootRoute;
    };
    '/knowledge': {
      id: '/knowledge';
      path: '/knowledge';
      fullPath: '/knowledge';
      preLoaderRoute: typeof KnowledgeImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/knowledge': {
      id: '/$workspaceSlug/knowledge';
      path: '/$workspaceSlug/knowledge';
      fullPath: '/$workspaceSlug/knowledge';
      preLoaderRoute: typeof WorkspaceSlugKnowledgeImport;
      parentRoute: typeof rootRoute;
    };
    '/feed': {
      id: '/feed';
      path: '/feed';
      fullPath: '/feed';
      preLoaderRoute: typeof FeedImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/feed': {
      id: '/$workspaceSlug/feed';
      path: '/$workspaceSlug/feed';
      fullPath: '/$workspaceSlug/feed';
      preLoaderRoute: typeof WorkspaceSlugFeedImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/spec-ai/tools': {
      id: '/settings/spec-ai/tools';
      path: '/settings/spec-ai/tools';
      fullPath: '/settings/spec-ai/tools';
      preLoaderRoute: typeof SettingsSpecAiToolsImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/spec-ai/tools': {
      id: '/$workspaceSlug/settings/spec-ai/tools';
      path: '/$workspaceSlug/settings/spec-ai/tools';
      fullPath: '/$workspaceSlug/settings/spec-ai/tools';
      preLoaderRoute: typeof WorkspaceSlugSettingsSpecAiToolsImport;
      parentRoute: typeof rootRoute;
    };
    '/settings/scoring/$entity': {
      id: '/settings/scoring/$entity';
      path: '/settings/scoring/$entity';
      fullPath: '/settings/scoring/$entity';
      preLoaderRoute: typeof SettingsScoringEntityImport;
      parentRoute: typeof rootRoute;
    };
    '/$workspaceSlug/settings/scoring/$entity': {
      id: '/$workspaceSlug/settings/scoring/$entity';
      path: '/$workspaceSlug/settings/scoring/$entity';
      fullPath: '/$workspaceSlug/settings/scoring/$entity';
      preLoaderRoute: typeof WorkspaceSlugSettingsScoringEntityImport;
      parentRoute: typeof rootRoute;
    };
  }
}

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  HomeRoute,
  NotificationsRoute,
  SpecRoute,
  ProjectsRoute,
  AccountsRoute,
  ContactsRoute,
  InvitesTokenRoute,
  WorkspaceSlugProjectsRoute,
  WorkspaceSlugHomeRoute,
  WorkspaceSlugNotificationsRoute,
  WorkspaceSlugSpecRoute,
  WorkspaceSlugAccountsRoute,
  WorkspaceSlugContactsRoute,
  WorkspaceSlugWelcomeRoute,
  SigninRoute,
  SignupRoute,
  SignupWorkspaceRoute,
  WorkspacesSelectRoute,
  SettingsRoute,
  SettingsProfileRoute,
  SettingsGeneralRoute,
  SettingsMembersRoute,
  SettingsSecurityRoute,
  SettingsBillingRoute,
  SettingsUsageRoute,
  SettingsAppearanceRoute,
  WorkspaceSlugSettingsRoute,
  WorkspaceSlugSettingsProfileRoute,
  WorkspaceSlugSettingsGeneralRoute,
  WorkspaceSlugSettingsMembersRoute,
  WorkspaceSlugSettingsSecurityRoute,
  WorkspaceSlugSettingsBillingRoute,
  WorkspaceSlugSettingsUsageRoute,
  WorkspaceSlugSettingsAppearanceRoute,
  SettingsSignalsRoute,
  WorkspaceSlugSettingsSignalsRoute,
  SettingsNotificationsRoute,
  WorkspaceSlugSettingsNotificationsRoute,
  SettingsApiKeysRoute,
  WorkspaceSlugSettingsApiKeysRoute,
  SettingsDeveloperMcpRoute,
  WorkspaceSlugSettingsDeveloperMcpRoute,
  ConnectorsRoute,
  WorkspaceSlugConnectorsRoute,
  SkillsRoute,
  WorkspaceSlugSkillsRoute,
  KnowledgeRoute,
  WorkspaceSlugKnowledgeRoute,
  FeedRoute,
  WorkspaceSlugFeedRoute,
  SettingsSpecAiToolsRoute,
  WorkspaceSlugSettingsSpecAiToolsRoute,
  SettingsScoringEntityRoute,
  WorkspaceSlugSettingsScoringEntityRoute,
});
